/**
 * i18n bootstrap for the client app.
 *
 * - Initializes `i18next` with `react-i18next` and browser language detection.
 * - Loads translation resources at runtime from the backend via
 *   `TranslationsApi.getTranslations` and registers them as resource bundles.
 */
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { TranslationsApi } from '../api/TranslationsApi';
import { translationLangaugeResource } from '../components/common/CommonTypes';

const loadTranslations = async () => {
  const abortController = new AbortController();

  const fetchTranslationsSuccess = (
    resources: translationLangaugeResource[]
  ) => {
    resources.forEach((lng) => {
      i18next.addResourceBundle(
        lng.Language,
        'translation',
        lng.Resources,
        false,
        true
      );
    });
  };

  const fetchTranslationsFailure = (error: string) => {
    console.log(error);
  };

  await new TranslationsApi().getTranslations(
    fetchTranslationsSuccess,
    fetchTranslationsFailure,
    abortController.signal
  );
};

export const initI18n = async () => {
  await i18next.use(initReactI18next).use(LanguageDetector).init({
    debug: true,
    fallbackLng: 'en',
    resources: {}
  });
  await loadTranslations();
};
